export const toggleVideoButtonComponent = {
  key: 'toggleVideoButtonComponent',
  name: 'Toggle Video Button Dept-Component',
  siteIdentifier: 'global',

  pauseLabel: 'Pause video',
  playLabel: 'Play video',
};
